import { Box, BoxProps, Typography } from "@mui/material";
import { PropsWithChildren } from "react";

type Props = {
  label: string;
  alignItems?: "flex-start" | "center";
  labelMaxWidth?: string;
  labelMinWidth?: string;
  BoxProps?: BoxProps;
};

const TalentFiltersRow = ({
  label,
  alignItems = "center",
  labelMaxWidth,
  labelMinWidth,
  BoxProps = {},
  children,
}: PropsWithChildren<Props>) => {
  return (
    <Box
      display="flex"
      alignItems={alignItems}
      gap="8px"
      justifyContent="flex-end"
      padding="6px 0px 0px 0px"
      width="100%"
      {...BoxProps}
    >
      <Typography
        textAlign="end"
        sx={{
          mt: alignItems === "flex-start" ? "8px" : "unset",
          maxWidth: labelMaxWidth || "unset",
          minWidth: labelMinWidth || "unset",
        }}
      >
        {label}
      </Typography>
      {children}
    </Box>
  );
};

export default TalentFiltersRow;
